import * as S from './ShareBlock.styled'
import {
  FacebookShareButton,
  PinterestShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  PinterestIcon
} from 'react-share'
import { LAYOUT_TEMPLATE } from '../../services/api/types'
import { PAGE_TEMPLATE } from '../../services/api/constants'
import { colors } from '../../styles/theme'

export interface ShareBlockProps {
  shareObj: SocialMedia
  template?: LAYOUT_TEMPLATE
}

export interface SocialMedia {
  image?: string
  shareUrl?: string
  description: string
  name: string
}

export interface ShareObjectProps {
  url: string
  title?: string
  quote?: string
  hashtag?: string
  imageUrl?: string
  image?: string
  subject?: string
}

export const ShareBlock = (props: ShareBlockProps) => {
  const { shareObj, template } = props
  let image = ''
  image = shareObj?.image || ''

  let shareObject: ShareObjectProps = {
    url: shareObj?.shareUrl || '',
    title: shareObj?.name || '',
    quote: shareObj?.description || '',
    hashtag: '#plusfitness',
    imageUrl: image,
    image: image
  }

  const iconBgStyle = {
    fill: template === PAGE_TEMPLATE.YOU_FITNESS ? colors.blue__deep : undefined
  }

  return (
    <S.ShareBlockSection template={template}>
      <S.ShareIconList>
        <span className='mr-2'>Share on</span>
        <S.ShareIconItem>
          <FacebookShareButton {...shareObject}>
            <FacebookIcon iconBgStyle={iconBgStyle} size={50} round />
          </FacebookShareButton>
        </S.ShareIconItem>
        <S.ShareIconItem>
          <TwitterShareButton {...shareObject}>
            <TwitterIcon iconBgStyle={iconBgStyle} size={50} round />
          </TwitterShareButton>
        </S.ShareIconItem>
        <S.ShareIconItem>
          <PinterestShareButton {...shareObject} media={image}>
            <PinterestIcon iconBgStyle={iconBgStyle} size={50} round />
          </PinterestShareButton>
        </S.ShareIconItem>
        <S.ShareIconItem>
          <LinkedinShareButton {...shareObject}>
            <LinkedinIcon iconBgStyle={iconBgStyle} size={50} round />
          </LinkedinShareButton>
        </S.ShareIconItem>
      </S.ShareIconList>
    </S.ShareBlockSection>
  )
}

export default ShareBlock
